<template>
   <div>
      <div class="scroll-zone"><div class="tab-wrap"><button
         v-for="tab in tabs"
         v-bind:key="tab.key"
         v-bind:class="['tab-button', { active: currentTab === tab.key }]"
         v-on:click="currentTab = tab.key">
         {{ tab.name }}
      </button></div></div>
      <component v-bind:is="currentTabComponent"></component>
   </div>
</template>

<script>
   // コンポーネントBをインポート
  import tabrd from '@/components/tab-rd';
  import tabmx from '@/components/tab-mx';
  import tabtr from '@/components/tab-tr';
  import tabed from '@/components/tab-ed';
  import tabsn from '@/components/tab-sn';
  import tabsm from '@/components/tab-sm';
  import tabwd from '@/components/tab-wd';
  import tabsc from '@/components/tab-sc';
  import tabdr from '@/components/tab-dr';
  import tabdt from '@/components/tab-dt';
  import Mixin from '@/mixins/mixin.js';
    export default {
       data() {
         return {
            currentTab: 'rd',
            tabs: [
              {
                 key: 'rd',
                 name: 'ROADRACE'
              },
              {
                 key: 'mx',
                 name: 'MOTOCROSS'
              },
              {
                 key: 'tr',
                 name: 'TRIAL'
              },
              {
                 key: 'ed',
                 name: 'ENDURO'
              },
              {
                 key: 'sm',
                 name: 'SUPERMOTO'
              },
              {
                 key: 'sn',
                 name: 'SNOWMOBILE'
              },
              {
                 key: 'dr',
                 name: 'DRAG RACE'
              },
              {
                 key: 'dt',
                 name: 'DIRT TRACK'
              },
              {
                 key: 'sc',
                 name: 'SUPER CROSS'
              },
              {
                 key: 'wd',
                 name: 'WORLD CHAMPION'
              },
            ]
         }
      },
      mixins: [Mixin],
      components: {
         'tab-rd': tabrd,
         'tab-mx': tabmx,
         'tab-tr': tabtr,
         'tab-sn': tabsn,
         'tab-sm': tabsm,
         'tab-wd': tabwd,
         'tab-dr': tabdr,
         'tab-ed': tabed,
         'tab-dt': tabdt,
         'tab-sc': tabsc,
      },
    }
</script>

<style lang="scss">
.scroll-zone{
    overflow-y: hidden;
    overflow-x: auto;
}
.tab-wrap{
    display: flex;
    padding: 0 10px;
    min-width: 1150px;
}
.tab-button {
  padding: 6px 10px;
  border: none;
  cursor: pointer;
  background: transparent;
  border-bottom: 1px solid #aaa;
  width: 10%;
  &.active{
    border: 1px solid #aaa;
    border-bottom: none;
    background: transparent;
  }
  &:hover{
    background: #CB0010;
  }
}

.tab-page {
  border: 1px solid #ccc;
  padding: 10px;
}

.champion-wrap{
    margin-top: 50px;
    padding: 0 50px;
}
.champion-container{
    position: relative;
    min-height: 170px;
}
.history__head.center{
    position: absolute;
    top: 0;
    left: calc(50% - 70px);
    height: 100%;
}
.champion-label{
    font-family: serif;
    text-align: center;
}
.champions{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 120px;
    &__sec{
        width: calc(50% - 120px);
        background: #fff;
        margin-bottom: 20px;
        padding: 20px;
        &:nth-child(odd){
            margin-top: -60px;
            margin-bottom: 80px;
        }
        ul{
            padding: 0;
            margin: 0;
        }
        li{
            display: block;
        }
    }
}
.year-title{
    font-family: serif;
    font-size: 25px;
    position: relative;
    font-weight: bold;
    margin: 0;
    &__sub{
        font-size: 0.6em;
        opacity: 0.4;
        display: inline-block;
        margin-left: 10px;
        font-family: "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, sans-serif;
    }
}
@media(max-width:1023px){
    .scroll-zone {
        margin-top: 60px;
    }
    .champion-wrap {
        padding: 0 20px;
    }
    .champion-container{
        display: flex;
        justify-content: space-between;
    }
    .history__head.center {
        position: relative;
        top: 0;
        left: 0;
        height: auto;
    }
    .champions{
        display: block;
        padding: 0;
        width: calc(100% - 80px);
        &__sec{
            width: 100%;
            box-sizing: border-box;
            &:nth-child(odd){
                margin: 0 0 20px;
            }
            li{
                font-size: 14px;
            }
        }
    }
    .year-title{
        font-size: 18px;
    }
    .champion-label{
        text-align: left;
    }
}
</style>